import LogTypes from './types'

export const searchRequest = (id_dossie) => ({
    type: LogTypes.SEARCH_REQUEST,
    payload: { id_dossie },
});

export const searchSuccess = (data) => ({
    type: LogTypes.SEARCH_SUCCESS,
    payload: data
});

export const searchFailure = () => ({
    type: LogTypes.SEARCH_FAILURE
})

export const registerRequest = (payload) => ({
    type: LogTypes.REGISTER_REQUEST,
    payload,
});

export const registerSuccess = () => ({
    type: LogTypes.REGISTER_SUCCESS,
});

export const registerFailure = () => ({
    type: LogTypes.REGISTER_FAILURE
})